import React, { Component } from "react";
import "./CarViewDetail.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CarModel from "../CarModel/CarModel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { isMobile } from "react-device-detect";
import ExpandCarDetail from "../ExpandCarDetail/ExpandCarDetail";

let value = "";
class CarViewDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      open: false
    };
  }

  handleChange = event => {
    this.setState({ value: event.target.value });
  };

  render() {
    return (
      <div>
        <Grid container style={{ textAlign: "center", marginTop: "80px" }}>
          <Grid item xs={12} sm={6}>
            <img src={this.props.image} className="CarImage" />
            <div className="CarChasis">{this.props.chasis}</div>
          </Grid>
          {isMobile ? (
            <ExpandCarDetail
              version={this.props.version}
              motor={this.props.motor}
              tipo={this.props.tipo}
              color={this.props.color}
              year={this.props.year}
              gear={this.props.gear}
              titulo1={this.props.titulo1}
              texto1={this.props.texto1}
              titulo2={this.props.titulo2}
              texto2={this.props.texto2}
              titulo3={this.props.titulo3}
              texto3={this.props.texto3}
            />
          ) : null}
          <Grid item xs={12} sm={6} style={{ padding: "0px" }}>
            <Grid
              item
              xs={12}
              sm={12}
              className={isMobile ? "CarGridMobile" : "CarGrid"}
            >
              <div className={isMobile ? "CarModelNameMobile" : "CarModelName"}>
                ¡Muy bien! {isMobile ? <br /> : null}Elegiste el{" "}
                {this.props.modelName} {this.props.version}
              </div>
              <div className={isMobile ? "CarVersionMobile" : "CarVersion"}>
                Armá tu paquete y reservalo al mejor precio del mercado.
              </div>
            </Grid>

            <Grid
              container
              xs={12}
              sm={12}
              offset={1}
              className={isMobile ? "CarDetailGridMobile" : "CarDetailGrid"}
            >
              <Grid
                container
                spacing={0}
                xs={12}
                sm={8}
                offset={1}
                className="CarDetailGridIn"
              >
                <Grid item xs={12} sm={12}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="patenta"
                      name="patenta1"
                      value={this.value}
                      onChange={this.handleChange}
                      className={"RadioGroup"}
                    >
                      <Grid
                        container
                        xs={12}
                        sm={12}
                        className={
                          this.state.value == "nosotros"
                            ? "CarDetailGridCellSelected"
                            : "CarDetailGridCell"
                        }
                      >
                        <Grid item spacing={0} xs={8} sm={8} className="Radio">
                          <FormControlLabel
                            value="nosotros"
                            control={<Radio />}
                            label="Patentas con Nosotros"
                            className="RadioLabel"
                          />
                          <div className="RadioDetail">
                            Nos brindás tu documentación. <br />
                            Te tomamos las firmas necesarias. <br /> Retirás la
                            unidad.
                          </div>
                        </Grid>
                        <Grid
                          item
                          spacing={0}
                          xs={4}
                          sm={4}
                          offset={1}
                          className="RadioPrecio"
                        >
                          $40.200
                          <div className="PriceDetail">
                            A este importe se le suma el importe de patente y
                            sellado que liquida el registro.
                          </div>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        xs={12}
                        sm={12}
                        className={
                          this.state.value == "tucuenta"
                            ? "CarDetailGridCellSelected"
                            : "CarDetailGridCell"
                        }
                      >
                        <Grid item spacing={0} xs={8} sm={8} className="Radio">
                          <FormControlLabel
                            value="tucuenta"
                            control={<Radio />}
                            label="Patentas por tu cuenta"
                            className="RadioLabel"
                          />
                          <div className="RadioDetail">
                            Te entregamos todos los formularios necesarios.{" "}
                            {isMobile ? null : <br />}
                            Presentás la documentacion en el registro.
                            {isMobile ? null : <br />}
                            Con las chapas en mano programamos la entrega.{" "}
                            <br />
                            Retirás la unidad.
                          </div>
                        </Grid>
                        <Grid
                          item
                          spacing={0}
                          xs={4}
                          sm={4}
                          offset={1}
                          className="RadioPrecio"
                        >
                          $40.200
                        </Grid>
                      </Grid>
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={3}
                className={
                  isMobile
                    ? "CarDetailGridCellPriceMobile"
                    : "CarDetailGridCellPrice"
                }
              >
                <div className={isMobile ? "PrecioMobile" : "Precio"}>
                  Precio Final <br />
                  <div style={{ fontSize: "0.8rem", color: "#EC1C24" }}>
                    Con Patentamiento
                  </div>{" "}
                  <div className={isMobile ? "PrecioNumMobile" : "PrecioNum"}>
                    <b>{this.props.price}</b>
                  </div>{" "}
                  <br />
                  <Link to="/carform">
                    <img
                      src="/img/reservar.png"
                      className={
                        isMobile
                          ? "ReservarImgDetailMobile"
                          : "ReservarImgDetail"
                      }
                    ></img>
                  </Link>
                  <br />
                  <div className={isMobile ? "MinimoMobile" : "Minimo"}>
                    mínimo de reserva <br />
                    <b>$5.000</b> <br /> <br />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default CarViewDetail;
